/**
 * Copyright 2025, IntraLinks, Inc. All rights reserved.
 */

import React from 'react';
import {
  IlCard,
  IlIconInitializer,
  IlStates
} from 'il-framework-component';
import { useTranslation } from 'react-i18next';
import Wrapper from '../../../../app/shared/components/Wrapper/Wrapper';
import { I18nNamespaces } from '../../../../app/shared/utils/constants.util';
import { useRequiredLevel } from '../../../../app/shared/utils/helpers.util';
import styles from './LoaProviders.scss';

const LoaProviders: React.FC = () => {
  const { t } = useTranslation(I18nNamespaces.LOA_ENRICHMENT);
  const level = useRequiredLevel();

  return (
    <>
      <IlIconInitializer />
      <Wrapper>
        <IlCard className={styles.cardForm}>
          <div className={styles.stateSectionContainer}>
            <IlStates
              illustration='empty'
              title={t('loaEnrichment.empty.enroll.title')}
              description={t('loaEnrichment.empty.enroll.description', { level })}
            />
          </div>
        </IlCard>
      </Wrapper>
    </>
  );
};

export default LoaProviders;
